<app-onboarding-circles [onboarding]="onboarding$|async"
    *ngIf="'circles' == environment.onboardingType"></app-onboarding-circles>
<app-onboarding-stepped [onboarding]="onboarding$|async"
    *ngIf="'stepped' == environment.onboardingType"></app-onboarding-stepped>